<template>
  <div class="chat">
    <myhead></myhead>
    <div class="mytit gud">
      {{ $t('a38') }}
      <span @click="goHis()" class="icon"></span>
    </div>
    <div class="bott"></div>
    <div class="msgbody" ref="msgbox">
      <div class="yourmsg clearfix">
        <div class="toux">
          <img src="../../assets/img/service-head.jpg">
        </div>
        <div class="msginfo">
          <div class="usname">{{ staffName}}</div>
          <div class="info deful">
            <span>
              <div>{{ $t('a53') }}</div>
              <div class="linee"></div>
              <p class="defmsg" v-for="(item,i) in Defmsg" @click="Defaultmsg(i)">
                <a :href="item.url" target="_blank">{{item.tit}}</a>
              </p>
            </span>
          </div>
        </div>
      </div>
      <!-- <div class="mymsg clearfix">
        <div class="toux rt">
          <img src="../../assets/img/service-head.jpg">
        </div>
        <div class="myinfo clearfix">
          <div class="usname">Customer service</div>
          <div class="cont clearfix">
            <span>{{ $t('a53') }}</span>
          </div>
        </div>
      </div>-->
      <template v-for="item in msgArr">
        <div v-if="item.flow === 'in' " class="yourmsg clearfix">
          <div class="toux">
            <img src="../../assets/img/service-head.jpg">
          </div>
          <div class="msginfo">
            <div class="usname">{{ item.fromNick }}</div>
            <div class="info">
              <span>{{ item.text }}</span>
            </div>
            <div class="time">{{ getTime(item.time) }}</div>
          </div>
        </div>
        <div v-else class="mymsg clearfix">
          <div class="toux rt">
            <img src="../../assets/img/service-user-head.jpg">
          </div>
          <div class="myinfo clearfix">
            <div class="usname">{{ item.from }}</div>
            <div class="cont clearfix">
              <span>{{item.text}}</span>
            </div>
            <div class="time">{{ getTime(item.time) }}</div>
          </div>
        </div>
      </template>
    </div>
    <div class="msg">
      <div class="left">
        <input @blur="bulrIos()" type="text" v-model="text">
      </div>
      <div class="right">
        <div @click="sendMsg()" class="btn">{{ $t('a57') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
let nim = null;
import { Toast } from "mint-ui";
// import { SDK } from "../../sdk/NIM_Web_SDK_v6.6.6";
export default {
  data() {
    return {
      customerAccid: "",
      customerToken: "",
      staffAccid: "",
      staffName: "",
      text: "",
      msgArr: [],
      Defmsg: [
        {
          tit: this.$t("a50"),
          url:
            "http://static.thextrend.com/product/xsxt/deposit_withdraw_time.html?language=en-US"
        },
        {
          tit: this.$t("a54"),
          url:
            "http://static.thextrend.com/product/xsxt/trade_time.html?language=en-US"
        },
        {
          tit: this.$t("a44"),
          url:
            "http://static.thextrend.com/product/xsxt/commissions.html?language=en-US"
        },
        {
          tit: this.$t("a55"),
          url:
            "http://static.thextrend.com/product/xsxt/overnight.html?language=en-US"
        }
      ]
    };
  },
  methods: {
    goHis() {
      this.$router.go(-1);
    },
    im() {
      // 测试
      let appKey1 = "878c8cdf58646d73329a9b9ecc015dcd";
      // 正式
      let appKey2 = "30253e4af067640cc46d52cd3c687208";
      let that = this;
      nim = this.SDK.NIM.getInstance({
        appKey: appKey2,
        account: this.customerAccid,
        token: this.customerToken,
        debug: false,
        onconnect(msg) {
          that.getHistoryMsgs();
        },
        onmsg(msg) {
          console.log(msg);
          if (msg) {
            that.msgArr.push(msg);
          }
        }
      });
    },
    sendMsg() {
      let that = this;
      if (!this.text.trim()) {
        Toast("The news can't be empty.");
        return;
      }
      nim.sendText({
        scene: "p2p",
        to: this.staffAccid,
        text: this.text,
        done(error, msg) {
          // console.log(msg);
          that.msgArr.push(msg);
        }
      });
      this.text = "";
    },
    getCustomer() {
      if (!this.$log.getLocalStorage("userId")) {
        let uid =
          "__uid_" + new Date().getTime() + "_" + ~~(Math.random() * 1e6);
        this.$log.setLocalStorage("uuuid", uid);
      }
      let data = {
        t: Date.now(),
        language: "en-US",
        loginType: 0,
        uid: this.$log.getLocalStorage("uuuid") || "",
        userId: this.$log.getLocalStorage("userId") || ""
      };
      let url = `${this.baseURL}news/api/helpline/web/clickV2/jsonp`;
      this.$jsonp(url, data)
        .then(res => {
          this.customerAccid = res.data.customerAccid;
          this.customerToken = res.data.customerToken;
          this.staffAccid = res.data.staffAccid;
          this.staffName = res.data.staffName;
          this.im();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getHistoryMsgs() {
      const staffAccid = this.staffAccid;
      const slef = this;
      nim.getHistoryMsgs({
        scene: "p2p",
        to: staffAccid,
        done(error, obj) {
          // console.log(obj);
          if (obj && obj.msgs && obj.msgs.length) {
            slef.msgArr = obj.msgs.reverse();
          }
        }
      });
    },
    getTime(data) {
      let myDate = new Date(+data);
      let year = myDate.getFullYear();
      let months = myDate.getMonth() + 1;
      let month = months.toString().length === 2 ? months : "0" + months;
      let date =
        myDate.getDate().toString().length === 2
          ? myDate.getDate()
          : "0" + myDate.getDate();
      let hours =
        myDate.getHours().toString().length === 2
          ? myDate.getHours()
          : "0" + myDate.getHours();
      let minutes =
        myDate.getMinutes().toString().length === 2
          ? myDate.getMinutes()
          : "0" + myDate.getMinutes();
      let seconds =
        myDate.getSeconds().toString().length === 2
          ? myDate.getSeconds()
          : "0" + myDate.getSeconds();
      return this.$log.getLocalStorage("language") === "zh-CN"
        ? year +
            "-" +
            month +
            "-" +
            date +
            " " +
            hours +
            ":" +
            minutes +
            ":" +
            seconds
        : year +
            "-" +
            month +
            "-" +
            date +
            " " +
            hours +
            ":" +
            minutes +
            ":" +
            seconds;
    },
    scorll() {
      let box = this.$refs.msgbox;
      // console.log(box.scrollHeight);
      setTimeout(function() {
        box.scrollTop = box.scrollHeight + 51;
      }, 10);
    },
    Defaultmsg(id) {
      let that = this;
      nim.sendText({
        scene: "p2p",
        to: this.staffAccid,
        text: this.Defmsg[id].tit,
        done(error, msg) {
          that.msgArr.push(msg);
        }
      });
    },
    bulrIos() {
      window.scroll(0, 0);
    }
  },
  created() {
    this.getCustomer();
    // this.im();
  },
  updated() {
    this.scorll();
  }
};
</script>

<style lang="less" scoped src="./chat.less">
</style>



// WEBPACK FOOTER //
// src/components/Chat/chat.vue